"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function Jump(props) {
  var _a = props || {},
      color = _a.color,
      opacity = _a.opacity;

  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.9"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 9C9.33579 9 9 9.33579 9 9.75C9 10.1642 9.33579 10.5 9.75 10.5H12.75C13.1642 10.5 13.5 10.8358 13.5 11.25V14.25C13.5 14.6642 13.8358 15 14.25 15C14.6642 15 15 14.6642 15 14.25V11.25C15 10.0074 13.9926 9 12.75 9H9.75Z",
    fill: color || "black",
    fillOpacity: opacity || '0.6'
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7657 10.2343C14.0781 10.5467 14.0781 11.0533 13.7657 11.3657L7.36569 17.7657C7.05327 18.0781 6.54673 18.0781 6.23431 17.7657C5.9219 17.4533 5.9219 16.9467 6.23431 16.6343L12.6343 10.2343C12.9467 9.9219 13.4533 9.9219 13.7657 10.2343Z",
    fill: color || "black",
    fillOpacity: opacity || '0.6'
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.71429C8 6.3198 8.3198 6 8.71429 6H14.4286C16.401 6 18 7.59898 18 9.57143V15.2857C18 15.6802 17.6802 16 17.2857 16C16.8912 16 16.5714 15.6802 16.5714 15.2857V9.57143C16.5714 8.38796 15.612 7.42857 14.4286 7.42857H8.71429C8.3198 7.42857 8 7.10877 8 6.71429Z",
    fill: color || "black",
    fillOpacity: opacity || '0.6'
  })));
}

var _default = Jump;
exports["default"] = _default;